// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class ExerciseRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_EXERCISE_REQUEST_MESSAGE, fieldSet);
    }
    setPositionID(positionID) {
        this.setFieldValue(FieldsFactory.FIELD_POSITION_ID, positionID);
    }
    setStatus(status) {
        this.setFieldValue(FieldsFactory.FIELD_STATUS, status);
    }
}
